import { logTrace } from '@/app/lcv/components/campaigns/big-campaign-2026/actions/logTrace';
import {
  buildTrace,
  type TraceFields,
  type TraceOutcome,
  type TraceStepKey,
} from '@/app/lcv/components/campaigns/big-campaign-2026/shared/trace';

/** Browser: logs a client-only step via the server (fire and forget). */
export const traceStep = (
  step: TraceStepKey,
  fields: TraceFields = {},
  outcome: TraceOutcome = 'info'
) => {
  logTrace(buildTrace(step, fields), outcome).catch(() => undefined);
};
